import Paper from '@aura/components/paper'
import { withStyles } from '@aura/components/styles'
import Typography from '@aura/components/typography'
import Box from '@aura/components/box'
import { useTranslation } from 'react-i18next'
import Divider from '@aura/components/divider'
import PropTypes from 'prop-types'
import styles from './styles'


const RegistrationContainer = ({
    children,
    classes,
    footerActions,
    mainContent,
    title,
    verbiage,
    variant = 'outlined',
}) => {

    const { t: translate } = useTranslation()
    return (<Paper 
        variant={variant}
        className={classes.container}
    >
        {/* Header Section with Title and Optional Close Button */}
        <Box className={classes.titleBox}>
            <Typography className={classes.title}>{title}</Typography>
        </Box>

        {/* Separator Line Below Header */}
        <Divider className={classes.headerDivider} />

        <Box className={classes.body}>
            <Typography className={classes.verbiage}>{verbiage}</Typography>

            <Paper className={classes.childrenContainer}>{children}</Paper>
        </Box>

        {/* Main Content Section */}
        {/* {mainContent || children} */}

        {/* Footer Section with Optional Separator */}
        {footerActions && (
            <Box className={classes.footerSection}>
                <Divider className={classes.footerDivider} />
                <Box className={classes.footerContent}>
                    {footerActions}
                </Box>
            </Box>
        )}
    </Paper>)
}

RegistrationContainer.propTypes = {
    children: PropTypes.object,
    classes: PropTypes.object,
    title: PropTypes.string,
    verbiage: PropTypes.string
}

export default withStyles(RegistrationContainer, styles)
